import React from "react";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";

import { IconButton } from "../../UI/IconButton";
import { useModalContext } from "../../contexts/ModalContext/context";
import { PlacementWorksheetSettingsModal } from "./PlacementWorksheetSettingsModal";
import { usePlacementWorksheetContext } from "../../contexts/PlacementWorksheetContext";

export const PlacementWorksheetSettings = () => {
  const { setIsOpen } = useModalContext();
  const { l2Id, l3Id } = usePlacementWorksheetContext();

  const openSettings = () => setIsOpen(true);

  if (!l3Id) return null;

  return (
    <>
      <IconButton onClick={openSettings} disabled={!l2Id || !l3Id}>
        <SettingsRoundedIcon sx={{ fontSize: 24 }} />
      </IconButton>
      <PlacementWorksheetSettingsModal />
    </>
  );
};
